import { makeStyles } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    container: {
        display: "flex", 
        // margin: "0 10px",
        color: theme.palette.secondary.main,
        justifyContent: "flex-end",
    
    },
    optionWrapper: {
        display:"flex", 
        padding: "10px 5px",
        margin: "0 2px",
        alignItems: "center",
        "& svg":{
          width: "20px",
          height: "20px",
          marginRight:"5px",
          marginLeft:"5px",
        },
        "&:hover": {
            cursor: "pointer",
            color: theme.palette.secondary.dark
          }
    }
 }));

 export const getMuiTheme = (selectedTheme) => {
  return createMuiTheme({
    ...selectedTheme,
    overrides: {
      MuiTooltip:{
          popper:{
              top:'-20px'
          },
          tooltipPlacementBottom:{
            margin:0,
            // eslint-disable-next-line no-useless-computed-key
            ["@media (min-width:600px)"]: {
                margin:0,
            }
        }
      },
      MuiIconButton:{
        root:{
          padding:"0px",
          "&:hover":{
            backgroundColor:"transparent",
          }
        },
      },
      
    },
  })
}